module.exports = coreApis.utils.title;